import React from 'react';
import { CircularProgress, Typography, FormControlLabel, Switch } from '@mui/material';
import MUIDataTable from "mui-datatables";
import sourceData from "./getSourceData";
import Navbar from "./components/Navbar"
import EmailButton from "./components/EmailButton"

class App extends React.Component {
  state = {
    count: 1,
    rowsPerPage: 100,
    sortOrder: {},
    data: [['Loading Data...']],
    isLoading: false,
    categories: []
  };

  componentDidMount() {
    this.getData('', 0);
  }

  // get data
  getData = async (url, page) => {
    this.setState({ isLoading: true });
    const res = await this.xhrRequest(url, page);
    this.setState({ data: res.data, isLoading: false, count: res.total, info: res.info, categories: res.categories });
  };

  sort = (page, sortOrder) => {
    this.setState({ isLoading: true });
    this.xhrRequest('', page, sortOrder).then(res => {
      this.setState({
        data: res.data,
        page: res.page,
        sortOrder,
        isLoading: false,
        count: res.total,
        info: res.info,
        categories: res.categories,
      });
    });
  };

  // mock async function
  xhrRequest = (url, page, sortOrder = {}, searchText, filterList=[], toggleWishlist = false) => {
    return new Promise((resolve, reject) => {
      sourceData().then(({data: fullData, info}) => {
        const wishlist = JSON.parse(localStorage.getItem("wishlist") ?? "[]");
        const categories = {}
        fullData.forEach(x => categories[x.Category] = 0);
        fullData = fullData.map(x => ({...x, wishlist: wishlist.includes(x['Product code'])}));
        let sortField = sortOrder.name;
        let sortDir = sortOrder.direction;
        if (searchText) {
          const searchWords = searchText.toUpperCase().split(' ');
          fullData = fullData.filter(x => {
            const description = x.Description?.toUpperCase() || '';
            const descriptionMatches = searchWords.every(word => description.includes(word));
            return descriptionMatches || x['Product code']?.toUpperCase().includes(searchText.toUpperCase()) || x['EDP Code']?.toUpperCase().includes(searchText.toUpperCase())
          })
        }
        if (filterList.length > 0) {
          fullData = fullData.filter(x => filterList.includes(x.Category))
        }
        if(toggleWishlist.length > 0){
          fullData= fullData.filter(x => (toggleWishlist.includes('✔️') && x.wishlist) || (toggleWishlist.includes('❌') && !x.wishlist))
        }

        const total = fullData.length;
        
        if (sortField) {
          fullData = fullData.sort((a, b) => {
            if (a[sortField] < b[sortField]) {
              return 1 * (sortDir === 'asc' ? -1 : 1);
            } else if (a[sortField] > b[sortField]) {
              return -1 * (sortDir === 'asc' ? -1 : 1);
            } else {
              return 0;
            }
          });
        }

        const data = fullData.slice(page * this.state.rowsPerPage, (page + 1) * this.state.rowsPerPage);
        resolve({
          data,
          total,
          page,
          info,
          categories: Object.keys(categories) ?? [],
        });
      }).catch(e => {
        console.error(e);
        reject(e);
      });
    });
  };

  changePage = (page, sortOrder) => {
    this.setState({
      isLoading: true,
    });
    this.xhrRequest(`/myApiServer?page=${page}`, page, sortOrder).then(res => {
      this.setState({
        isLoading: false,
        page: res.page,
        sortOrder,
        data: res.data,
        count: res.total,
        info: res.info,
        categories: res.categories,
      });
    });
  };

  changeData = (page, sortOrder, searchText, filterList, toggleWishlist) => {
    this.setState({
      isLoading: true,
    });
    this.xhrRequest(`/myApiServer?page=${page}`, page, sortOrder, searchText, filterList, toggleWishlist).then(res => {
      this.setState({
        isLoading: false,
        page: res.page,
        sortOrder,
        data: res.data,
        count: res.total,
        info: res.info,
        categories: res.categories,
      });
    });
  };


  render() {
    const { data, count, isLoading, rowsPerPage, sortOrder, categories } = this.state;

    const options = {
      filter: true,
      filterType: 'dropdown',
      responsive: 'standard',
      serverSide: true,
      count: count,
      rowsPerPageOptions: [],
      rowsPerPage: rowsPerPage,
      jumpToPage: true,
      sortOrder: sortOrder,
      selectableRows: 'none',
      customFilterDialogFooter: () => (<p style={{visibility:"hidden"}}>this is a very long test to see what will happen</p>),
      onTableChange: (action, tableState) => {

        // a developer could react to change on an action basis or
        // examine the state as a whole and do whatever they want

        switch (action) {
          case 'changePage':
          case 'search':
          case 'filterChange':
          case 'resetFilters':
          case 'sort':
            this.changeData(tableState.page, tableState.sortOrder, tableState.searchText, tableState.filterList[3], tableState.filterList[6]);
            break;
          default:
            //console.log('action not handled:', action);
            //console.log(action, tableState);
        }
      },
    };

    const columns = [
      {
        name: 'Product code',
        label: 'Product Code',
        options: {filter: false},
      },
      {
        name: 'EDP Code',
        label: 'EDP Code',
        options: {
          filter: false,
          customBodyRender: (value) => {
            const newValue = value?.split(',').reduce((prevVal,currentVal) => {
              if(currentVal.trim()) prevVal.push(currentVal.trim());
              return prevVal;
            },[]).join('\r\n');
            return <pre>{newValue}</pre>
          }

        },
      },
      {
        name: 'Description',
        label: 'Description',
        options: { filter: false},
      },
      {
        name: 'Category',
        label: 'Category',
        options: {filterOptions: {names: categories}},
      },
      {
        name: 'Price (Ex VAT)',
        label: 'Price (Ex VAT)',
        options: {
          filter: false,
          customBodyRender: (value, tableMeta, updateValue) => {
            const nf = new Intl.NumberFormat('en-ZA', {
              style: 'currency',
              currency: 'ZAR',
              minimumFractionDigits: 2,
              maximumFractionDigits: 2
            });
            return value ? nf.format(value) : "";
          }
        },
      },
      {
        name: 'Stock on hand',
        label: 'Stock',
        options: {filter: false},
      },
      {
        name: 'wishlist',
        label: 'Wishlist',
        options: {
          filterOptions: {names: ['✔️','❌']},
          customBodyRender: (value, tableMeta, updateValue) => {
            const toggleWishlist = (v) =>{
              const prodCode = tableMeta.rowData[0];
              const newWishlist = JSON.parse(localStorage.getItem("wishlist") ?? "[]").filter(x => x !== prodCode)
              if(v){
                newWishlist.push(prodCode)
              }
              localStorage.setItem("wishlist", JSON.stringify(newWishlist));
              return updateValue(v);
            };
            return (
              <FormControlLabel
                label={value ? "✔️" : "❌"}
                value={value ? "✔️" : "❌"}
                control={
                  <Switch color="primary" checked={value} value={value ? "✔️" : "❌"} onChange={e => toggleWishlist(e.target.value === "✔️" ? false : true)} />
                }
              />
            );

          }
          
        },
      },
    ];


    return (
      <div>
        <Navbar data={this.state.info} />
        <MUIDataTable
          title={
            <Typography variant="h6">
              Vehicle Parts Clearance Catalogue
              {isLoading && <CircularProgress size={24} style={{ marginLeft: 15, position: 'relative', top: 4 }} />}
            </Typography>
          }
          data={data}
          columns={columns}
          options={options}
        />
        <EmailButton/>
      </div>
    );
  }
}

export default App;